import {useEffect, useState} from "react";
import {moveModal} from "../../utils/Utils";
import TeacherConstant from "../../utils/constants/TeacherConstant";
import UserSelector from "../../elements/selector/UserSelector";
import proxy from "../../utils/Proxy";

let LessonReservationModal = (props) => {
    let [userid, setUserid] = useState(null)
    let [username, setUsername] = useState(null)
    let [isExternal, setIsExternal] = useState(false);

    useEffect(() => {
        setIsExternal(false)
    }, [props.opened])

    let getTeacherName = () => {
        let teacherid = props.teacherid;
        if (typeof props.data.teachers[teacherid] === "undefined") {
            return "선생님 정보 없음";
        }
        let teacher = props.data.teachers[teacherid];
        return TeacherConstant.major_symbol[teacher.major] + teacher.name;
    }

    let onClickReservation = (_) => {
        if (props.isAdmin) {
            let finalUserid = userid;
            let finalUsername = username;
            let isGrand = document.getElementById("isgrand-checkbox").checked;
            let externalInput =
                document.getElementById("external-lesson-username-input");
            let externalContactInput = document.getElementById("external-lesson-contact-input");
            let contact = null;

            if (!isExternal && userid === null) {
                return alert("회원을 선택한 후 다시 시도해주세요.")
            }
            if (isExternal) {
                finalUsername = externalInput.value;
                contact = externalContactInput.value;
                if (finalUsername === null || finalUsername === "" || contact == null || contact === "")
                    return alert("외부레슨인 경우 수강생 이름과 전화번호를 입력해주세요.")
                finalUserid = null;
            }

            let body = {
                userid: finalUserid,
                username: finalUsername,
                due: props.dateString,
                hour: props.hour,
                location: props.location,
                is_grand: isGrand,
                teacherid: props.teacherid,
                contact: contact
            }

            proxy.post("/adminapi/lessons", body).then(_ => {
                window.alert("레슨 예약이 완료되었습니다.");
                props.setNeedUpdate(true)
                props.setOpened(false)
            }).catch((err) => {
                window.alert(err.response.data.message);
            })
        } else {
            let isGrand = document.getElementById("isgrand-checkbox").checked;
            let body = {
                due: props.dateString,
                hour: props.hour,
                location: props.location,
                is_grand: isGrand,
                teacherid: props.teacherid
            }

            proxy.post("/api/lessons", body).then(_ => {
                window.alert("레슨 예약이 완료되었습니다.");
                props.setNeedUpdate(true)
                props.setOpened(false)
                props.setNeedInfoRefresh(true)
            }).catch((err) => {
                props.setNeedUpdate(true)
                props.setOpened(false)
                window.alert(err.response.data.message);
            })
        }
    }

    let onCheckboxChange = (e) => {
        let checked = e.target.checked;
        let userSelected = document.getElementById("user-selected");
        let userSelectorInputName = document.getElementById("user-selector-username-input");
        let userSelectorInputContact = document.getElementById("user-selector-contact-input");
        let userSelectorSearchButton = document.getElementById("user-selector-search-button");
        if (checked) {
            if (userSelected !== null)
                userSelected.style = "display: none";
            userSelectorInputName.disabled = true
            userSelectorInputContact.disabled = true
            userSelectorSearchButton.style = "pointer-events: none;";
        } else {
            if (userSelected !== null)
                userSelected.style = "display: flex";
            userSelectorInputName.disabled = false
            userSelectorInputContact.disabled = false
            userSelectorSearchButton.style = "pointer-events: auto;";
        }
        setIsExternal(checked);
    }

    let onClickResult = (user) => {
        setUsername(user.name)
        setUserid(user.userid)
    }

    return props.opened ? (<div className="modal-container">
            <div className="modal" id="lesson-reservation-modal">
                <div className="modal-content-container">
                    <div className="modal-header" onMouseDown={e => moveModal(e, "lesson-reservation-modal")}>
                        <p className="modal-title">
                            레슨 신규예약
                        </p>
                        <div className="modal-close-button" onClick={props.onCloseClick}></div>
                    </div>
                    <div className="modal-content" id="lesson-reservation-modal-content">
                        <ul>
                            <div className="modal-content-item">
                                <li className="modal-content-text">
                                    레슨 일시: {props.dateString + " " + props.hour + "시"}
                                </li>
                            </div>
                            <div className="modal-content-item">
                                <li className="modal-content-text">
                                    레슨 선생님: {getTeacherName()}
                                </li>
                            </div>
                            {props.isAdmin ? <>
                                <div className="modal-content-item">
                                    <li className="modal-content-text">
                                        레슨 회원 선택
                                    </li>
                                </div>
                                <div className="modal-content-item">
                                    <UserSelector onClickResult={onClickResult}></UserSelector>
                                    {username === null ? null : <p id="user-selected">{username}</p>}
                                </div>
                                <div className="modal-content-item">
                                    <li className="modal-content-text">
                                        외부레슨 여부
                                    </li>
                                    <input type="checkbox" id="external-lesson-checkbox"
                                           onChange={onCheckboxChange.bind(this)}/>
                                    {isExternal ? <div className="external-input-container">
                                        <input
                                            id="external-lesson-username-input"
                                            placeholder="외부 수강생 이름"/>
                                        <input id="external-lesson-contact-input"
                                               placeholder="전화번호"/>
                                    </div> : null}
                                </div>
                            </> : <div className="modal-content-item">
                                <li className="modal-content-text">
                                    남은 레슨 횟수: {props.myInformation.lesson_count}
                                </li>
                            </div>}

                            <div className="modal-content-item">
                                <li className="modal-content-text">
                                    그랜드 레슨 여부
                                </li>
                                <input type="checkbox" id="isgrand-checkbox" defaultChecked={true}/>
                            </div>
                        </ul>
                    </div>
                    <div className="modal-footer">
                        <div className="modal-footer-button-container">
                            <div className="modal-button" onClick={onClickReservation}>
                                <p>레슨 예약하기</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : null;
}
export default LessonReservationModal;